import { useState } from 'react'
import FormLoader from '../../../../components/loader/FormLoader'
import Modal from '../../../../components/modal/Modal'
import { post } from '../../../../utils/Api'
import { useGlobalContext } from '../../../../utils/Context'
import { Icon } from '@iconify/react'
import '../customers/CustomerModals.scss'

function ToggleBusinessEarlyWaybillAccess({
  businessId,
  orgName,
  currentValue,
  onSuccess,
  onClose,
}: any) {
  const { notify } = useGlobalContext()
  const [loading, setLoading] = useState(false)

  async function confirm() {
    setLoading(true)
    post(
      `admin/business/${businessId}/toggle-early-waybill-access`,
      { name: 'hello' },
      null,
    )
      .then((result: any) => {
        if (result.success) {
          notify('success', result.message)
          onSuccess(result.data.earlyWaybillAccess)
          onClose()
        } else {
          notify('error', result.message)
        }
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
      })
  }

  const isEnabling = !currentValue

  return (
    <Modal position='center'>
      <div className='customer-modal'>
        <div className='modal-header'>
          <div
            className={`modal-icon ${isEnabling ? 'icon-green' : 'icon-red'}`}
          >
            <Icon icon={isEnabling ? 'mdi:eye-outline' : 'mdi:eye-off-outline'} />
          </div>
          <h2>{isEnabling ? 'Enable' : 'Disable'} Early Waybill Access</h2>
          <p>
            {isEnabling
              ? `${orgName || 'This business'} will be able to view its waybill before the shipment is marked collected. That early waybill is always barcode-redacted — once the shipment is actually collected, they see the full waybill exactly like everyone else (barcode shown only for imports).`
              : `${orgName || 'This business'} will go back to seeing no waybill at all until the shipment is marked collected, same as a regular account.`}
          </p>
        </div>

        <div
          className={`status-indicator ${currentValue ? 'status-on' : 'status-off'}`}
        >
          <div className='dot' />
          <p>
            Current status: <span>{currentValue ? 'Enabled' : 'Disabled'}</span>
          </p>
        </div>

        {loading ? (
          <FormLoader position='center' />
        ) : (
          <div className='modal-actions'>
            <button className='btn-cancel' onClick={onClose}>
              Cancel
            </button>
            <button
              className={isEnabling ? 'btn-proceed' : 'btn-danger'}
              onClick={confirm}
            >
              {isEnabling ? 'Enable' : 'Disable'}
            </button>
          </div>
        )}
      </div>
    </Modal>
  )
}

export default ToggleBusinessEarlyWaybillAccess
